import React from "react";
import ProductGallery from "../../GalleryImagesComponent";
import Image1 from "../../../../Product/School_Uniforms/Pinafores/PF1.webp";
import Image2 from "../../../../Product/School_Uniforms/Pinafores/PF2.webp";
import Image3 from "../../../../Product/School_Uniforms/Pinafores/PF3.webp";
import Image4 from "../../../../Product/School_Uniforms/Pinafores/PF4.webp";
import Image5 from "../../../../Product/School_Uniforms/Pinafores/PF5.webp";
import Image6 from "../../../../Product/School_Uniforms/Pinafores/PF6.webp";
import Image7 from "../../../../Product/School_Uniforms/Pinafores/PF7.webp";
import Image8 from "../../../../Product/School_Uniforms/Pinafores/PF8.webp";
import Image9 from "../../../../Product/School_Uniforms/Pinafores/PF9.webp";
import Image10 from "../../../../Product/School_Uniforms/Pinafores/PF10.webp";
import Image11 from "../../../../Product/School_Uniforms/Pinafores/PF11.webp";
import Image12 from "../../../../Product/School_Uniforms/Pinafores/PF12.webp";

const PinaFores = () => {
  const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9, Image10, Image11, Image12];

  return (
    <ProductGallery
      images={images}
      category={{ english: "school_uniform", enName: "Educational", arabic: "التعليم", arName: "التعليم" }}
      product={{ english: "PinaFores", arabic: "مريولات" }}
    />
  );
};

export default PinaFores;
